export default __webpack_public_path__ + "static/media/camera_white.43663898.png";